import type { ReplaceMeterStore } from 'routes/meter_replacement/useStore';
import { SetState } from 'zustand';

/* eslint-disable camelcase */
export interface ReviewStepForm {}

const INITIAL_STATE: ReviewStepForm = {};

export interface ReviewStepSlice extends ReviewStepForm {
  resetReviewStepSlice: (initValues?: Partial<ReviewStepForm>) => void;
}

export const createReviewStepSlice = (set: SetState<ReplaceMeterStore>): ReviewStepSlice => ({
  ...INITIAL_STATE,
  resetReviewStepSlice: (initValues = {}) => set({ ...INITIAL_STATE, ...initValues }),
});
